import { render, staticRenderFns } from "./CollectionFilterControlTypeInternalLink.vue?vue&type=template&id=65879550"
import script from "./CollectionFilterControlTypeInternalLink.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionFilterControlTypeInternalLink.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports